///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { forwardRef } from "react";
import _sortBy from "lodash/sortBy";

import ActiveBid from "./ActiveBid";
import Loader from "./Loader";
import messages from "../helpers/messages";
import { status } from "../helpers/types";
import { orderBy } from "lodash";

const statusToListIdMap = {
  [status.pending]: "pending-bids-list-title",
  [status.inProgress]: "in-progress-bids-list-title",
  [status.submitted]: "submitted-bids-list-title",
  [status.feedback]: "feedback-bids-list-title"
};

const statusToListTitleMap = {
  [status.pending]: messages.pending.defaultMessage,
  [status.inProgress]: messages.inProgress.defaultMessage,
  [status.submitted]: messages.submitted.defaultMessage,
  [status.feedback]: messages.feedback.defaultMessage
};

const statusToLoaderTestIdMap = {
  [status.pending]: "pending-bids-loader-container",
  [status.inProgress]: "inProgress-bids-loader-container",
  [status.submitted]: "submitted-bids-loader-container",
  [status.feedback]: "feedback-bids-loader-container"
};

const ActiveBidsList = (props, ref) => {
  const sortField =
    props.status === status.feedback ? "startDateUTC" : "deadlineDateUTC";
  const bids = props.sortByRfqCloseDate
    ? _sortBy(props.bids, sortField)
    : orderBy(props.bids, [
        bid =>
          bid.bidName && bid.bidName.toLowerCase && bid.bidName.toLowerCase()
      ]);

  return (
    <dl
      className={`bids-list mb-0 ${props.isFetching ? "flex flex-col" : ""}`}
      style={{ height: props.isFetching ? "auto" : props.height }}
      ref={ref}
    >
      <dt
        id={statusToListIdMap[props.status]}
        className="bids-list-title beta-body-copy p-12 pt-16 px-24"
      >
        {statusToListTitleMap[props.status] +
          (props.isFetching ? "" : ` (${props.bids.length})`)}
      </dt>
      {props.isFetching ? (
        <dt
          className="bid flex justify-center items-center flex-grow-0 flex-shrink-0 bid-fetching"
          data-testid={statusToLoaderTestIdMap[props.status]}
        >
          <Loader />
        </dt>
      ) : (
        <div className="card-container scroll pb-6">
          {bids.map(bid => (
            <ActiveBid bid={bid} key={bid.bidId} status={props.status} />
          ))}
        </div>
      )}
    </dl>
  );
};

export default forwardRef(ActiveBidsList);
